/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const $kjc = new Set([6196, 6133]);
export const $ljc = new Set([6138]);
export const $mjc = new Set([6192]);
export const $njc = new Set([7027]);
export const $ojc = new Set([7028]);
export const $pjc = new Set([7029]);
export const $qjc = new Set([7030]);
export const $rjc = new Set([2420]);
export const $sjc = new Set([2552, 2304]);
export const $tjc = new Set([2689]);
export const $ujc = new Set([1308]);
